import api from './api';

const ReviewService = {
    getProductReviews: async (productId) => {
        const response = await api.get(`/reviews/?product_id=${productId}`);
        return response.data;
    },

    createReview: async (data) => {
        // data is FormData because of images
        const response = await api.post('/reviews/', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    },

    getMyReviews: async () => {
        const response = await api.get('/reviews/my_reviews/');
        return response.data;
    }
};

export default ReviewService;
